import { useRef } from 'react';

// Abaixo disso é um clique comum, não um arraste.
const DRAG_THRESHOLD_PX = 5;

/**
 * Arrastar com o mouse rola o container na horizontal (no toque, o navegador
 * já rola sozinho). Usado na fileira de chips quando não cabe na tela, como
 * no WhatsApp. Devolve as props do container: `<Stack {...dragScroll}>`.
 *
 * O clique que encerra um arraste é descartado (na fase de captura, antes de
 * chegar ao chip), para soltar o mouse sobre um chip não selecioná-lo.
 */
export default function useDragScroll() {
  const drag = useRef(null);
  const dragged = useRef(false);

  return {
    onPointerDown: (event) => {
      dragged.current = false;
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      drag.current = { x: event.clientX, scrollLeft: event.currentTarget.scrollLeft };
    },
    onPointerMove: (event) => {
      if (!drag.current) return;
      const dx = event.clientX - drag.current.x;
      if (!dragged.current) {
        if (Math.abs(dx) < DRAG_THRESHOLD_PX) return;
        dragged.current = true;
        // Segue o arraste mesmo com o mouse fora da fileira.
        event.currentTarget.setPointerCapture?.(event.pointerId);
      }
      event.currentTarget.scrollLeft = drag.current.scrollLeft - dx;
    },
    onPointerUp: () => { drag.current = null; },
    onPointerCancel: () => { drag.current = null; },
    onClickCapture: (event) => {
      if (!dragged.current) return;
      dragged.current = false;
      event.stopPropagation();
      event.preventDefault();
    },
  };
}
